import { Controller } from 'stimulus';
import morphDom from 'morphdom';
import Utility from 'classes/Utility';

const COUNTDOWN_TIME = 15;

class WelcomeInterstitialController extends Controller {
  static targets = [
    'modal',
    'countdown',
    'tableHeaderContainer',
    'tableContentContainer',
    'sponsoredContainer',
    'tableContainer'
  ]

  async initialize() {
    const welcomeInterParam = Utility.getUrlParam('force-welcome-interstitial');
    if (welcomeInterParam === 'true') {
      this.openModal()
    } else {
      try {
        const response = await Utility.getConfigData({type: 'master_switch', name: 'Welcome Interstitial'});
        const { data } = response;
        const { data: state } = data;
        const deviceType = Utility.getDeviceType();
        const viewedCookie = Utility.getCookie('welcome_interstitial_with_ad');
        if (viewedCookie == 'unknown' && state && deviceType === 'dt') {
          this.openModal();
        }
      } catch(e) {
        // ignore failed request and proceed
      }
    }
  }

  connect() {
    this.domId = this.element.id;

    EventManager.on('modal_state', ({ showState, domId, handleClose = null }) => {
      if (Utility.getDeviceType() !== 'dt') return;

      if (domId == this.domId) {
        this.handleClose = handleClose;
        if (showState == 'true') {
          const viewedCookie = Utility.getCookie('welcome_interstitial_with_ad');
          if (viewedCookie == 'unknown') {
            this.openModal();
          }
        } else {
          this.closeModal();
        }
      }
    });
  }

  __renderTableHeader = () => {
    if (this.hasTableHeaderContainerTarget) {
      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'show')
      container.setAttribute('data-component-render-url', '/api/components/welcome-interstitial-header/')
      container.setAttribute('data-component-render-url-method', 'get');
      container.classList.add('t-w-full', 't-flex')
      this.tableHeaderContainerTarget.innerHTML = '';
      this.tableHeaderContainerTarget.appendChild(container);
    }
  }

  __renderSponsoredRows = () => {
    if (this.hasSponsoredContainerTarget) {
      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'show')
      container.setAttribute('data-component-render-url', '/api/components/welcome-interstitial-sponsored/')
      container.setAttribute('data-component-render-url-method', 'get');
      container.classList.add('t-w-full', 't-flex')
      this.sponsoredContainerTarget.innerHTML = '';
      this.sponsoredContainerTarget.appendChild(container);
    }
  }

  __renderTableContent = () => {
    if (this.hasTableContentContainerTarget) {
      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'show')
      container.setAttribute('data-component-render-url', '/api/components/welcome-interstitial-rows/')
      container.setAttribute('data-component-render-url-method', 'get');
      container.classList.add('t-w-full', 't-flex')
      const wrapper = document.createDocumentFragment();
      wrapper.appendChild(container);
      morphDom(this.tableContentContainerTarget.firstChild, wrapper);
    }
  }

  closeModal = e => {
    if (e) {
      e.preventDefault();
    }
    const body = document.querySelector('body')
    body.classList.remove('t-fixed')
    this.modalTarget.classList.remove('active')

    if (this.handleClose) {
      this.handleClose();
    }

    setTimeout(() => {
      this.disconnect()
    }, 300)
  }

  openModal = e => {
    if (e) {
      e.preventDefault();
    }
    Utility.setCookieWithExpiration('welcome_interstitial_with_ad', 'true', 'session');

    this.__renderTableHeader()
    this.__renderSponsoredRows()
    this.__renderTableContent()

    const body = document.querySelector('body')
    body.classList.add('t-fixed')
    this.modalTarget.classList.add('active')
    this.startTimer(COUNTDOWN_TIME, this.countdownTarget);
  }

  startTimer = (duration, display) => {
    let timer = duration;
    let seconds;
    setInterval(() => {
      seconds = parseInt(timer % 60, 10);

      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = `or wait ${seconds} secs`;

      if (--timer < 0) {
        this.closeModal()
      }
    }, 1000);
  }
}

export default WelcomeInterstitialController;
